var a="data-focus-lock",o="data-focus-lock-disabled",c="data-no-focus-lock",d="data-autofocus-inside",t="data-no-autofocus";export{c as FOCUS_ALLOW,d as FOCUS_AUTO,o as FOCUS_DISABLED,a as FOCUS_GROUP,t as FOCUS_NO_AUTOFOCUS};
//# sourceMappingURL=constants.js.map
